import { GridItem as ChakraGridItem, GridItemProps } from '@chakra-ui/react';

// 就業報告のフォームの縦の間隔調整
// ※現時点では就業報告のみで使用しているが、他でも使用となったら components に上げる。
export const GridItem = (props: GridItemProps) => (
  <ChakraGridItem marginBottom={2} {...props}></ChakraGridItem>
);
